import { render } from "./LightboxCategoryBestSellerSkeleton.vue?vue&type=template&id=d8d9fb46&scoped=true"
import script from "./LightboxCategoryBestSellerSkeleton.vue?vue&type=script&lang=js"
export * from "./LightboxCategoryBestSellerSkeleton.vue?vue&type=script&lang=js"

import "./LightboxCategoryBestSellerSkeleton.vue?vue&type=style&index=0&id=d8d9fb46&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d9fb46"]])

export default __exports__